import React, { ReactNode } from 'react';
import { Badge } from 'react-bootstrap';

import { DateTimeService } from 'src/services/DateTimeService';

import { OrderStatusCategory } from '../../../providers';

export const StatusBadge = ({
  statusCategory,
  completedAt,
  children,
}: {
  statusCategory: OrderStatusCategory;
  completedAt?: null | string;
  children: ReactNode;
}) => (
  <Badge variant={STATUS_VARIANT_MAP[statusCategory]} className="mt-1">
    {children}{' '}
    {statusCategory === OrderStatusCategory.Completed && completedAt && DateTimeService.format(completedAt, 'DD.MM.YY')}
  </Badge>
);

const STATUS_VARIANT_MAP: Record<OrderStatusCategory, string> = {
  [OrderStatusCategory.Draft]: 'primary',
  [OrderStatusCategory.Confirmed]: 'primary',
  [OrderStatusCategory.InProgress]: 'primary',
  [OrderStatusCategory.Completed]: 'success',
  [OrderStatusCategory.Canceled]: 'danger',
  [OrderStatusCategory.Unknown]: 'warning',
  [OrderStatusCategory.OnCoordination]: 'primary',
  [OrderStatusCategory.WaitInPickPoint]: 'primary',
};
